import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import {IntegrationModel, WbdModel} from "../../models/integration/integration.model";
import {TrainingLocationTypeModel} from "../../models/training/training-location-type.model";
import {Configuration} from "../../../assets/Configuration";

@Injectable({
    providedIn: 'root'
})
export class IntegrationsService {

    public static integrationsUrl = '/integrations';

    public static webexRedirectUrl = Configuration.getIntegrationRedirectUrl('webex');
    public static goToWebinarRedirectUrl = Configuration.getIntegrationRedirectUrl('gotowebinar');
    public static teamRedirectUrl = Configuration.getIntegrationRedirectUrl('msteams');
    public static teamsMeetingsRedirectUrl = Configuration.getIntegrationRedirectUrl('msteams-meetings');
    public static goToZoomRedirectUrl = Configuration.getIntegrationRedirectUrl('zoom');

    constructor(private httpClient: HttpClient) {
    }

    public getIntegrations(): Observable<IntegrationModel[]> {
        return this.httpClient.get<IntegrationModel[]>(Configuration.getApiBaseUrl() + '/integration');
    }

    public getOAuthUrl(trainingLocationType: TrainingLocationTypeModel, redirectUrl: string): Observable<string> {
        debugger;
        const params = new HttpParams()
            .set('redirectUrl', redirectUrl);
            
        return this.httpClient.get(
            Configuration.getApiBaseUrl() + '/Integration/' + trainingLocationType + '/oauth-url', 
            {
                params: params,
                responseType: 'text'
            }
        );
    }
    public getOAuthUrlTeam(trainingLocationType: TrainingLocationTypeModel, redirectUrl: string): Observable<string> {
        const params = new HttpParams()
            .set('redirectUrl', redirectUrl);

        return this.httpClient.get(
            Configuration.getApiBaseUrl() + '/Integration/' + trainingLocationType + '/oauth-url',
            {
                params: params,
                responseType: 'text'
            }
        );
    }

    public disconnect(trainingLocationType: TrainingLocationTypeModel): Observable<void> {
        return this.httpClient.post<void>(Configuration.getApiBaseUrl() + '/Integration/' + trainingLocationType + '/disconnect', null);
    }

    public integrate(trainingLocationType: TrainingLocationTypeModel, code: string, redirectUrl: string): Observable<void> {
        const params = new HttpParams()
            .set('code', code)
            .set('redirectUrl', redirectUrl);

        return this.httpClient.post<void>(
            Configuration.getApiBaseUrl() + '/Integration/' + trainingLocationType + '/integrate', 
            null,
            { params: params }
        );
    }

    public getWbd(): Observable<boolean> {
        return this.httpClient.get<boolean>(Configuration.getApiBaseUrl() + '/Wbd/configured');
    }
    
    public configureWbd(wbdModel: WbdModel): Observable<WbdModel> {
        return this.httpClient.post<WbdModel>(Configuration.getApiBaseUrl() + '/Wbd', wbdModel);
    }

    public disconnectWbd(): Observable<void> {
        return this.httpClient.delete<void>(Configuration.getApiBaseUrl() + '/Wbd');
    }

    // private getRedirectUrl(): string {
    //   return window.location.origin + '/integrations/webex/oauth';
    // return window.location.origin + '/integrations/gotowebinar/oauth';
    // }
}
